export const UPDATE_USERS_SEARCH = 'UPDATE_USERS_SEARCH';

export interface SearchUsersPayload {
    query: string;
}

// Actions

export interface UpdateUsersSearchAction {
    type: typeof UPDATE_USERS_SEARCH;
    payload: SearchUsersPayload;
}

// Action creators

export const updateUsersSearch: (payload: SearchUsersPayload) => UpdateUsersSearchAction = (payload) => {
    return {
        type: UPDATE_USERS_SEARCH,
        payload,
    };
};
